import React, { createContext } from 'react';

const { Consumer, Provider } = createContext({ content: {} });

export const withLanguageContext = (Component) => (props) =>
	(
		<Consumer>
			{({ content }) => <Component {...props} content={content} />}
		</Consumer>
	);

export const LanguageContextProvider = Provider;



// WEBPACK FOOTER //
// ./src/utils/LanguageContext.js